<div style="padding: 20px;">
  <div>
    <h1>{{ title }}</h1>
  </div>
  <div style="display: flex; flex-direction: column; justify-content: left; align-items: center; margin-top: 10px">
    <div [innerHTML]="text | sanitizeHtml"></div>
    <button style="margin-top: 20px;" mat-raised-button (click)="onClose(true)">{{ button }}</button>
  </div>
</div>
